export const RESOURCE_EVENTS = {
  CLICKED_DOWNLOAD: 'Clicked Download',
  OPENED_DOWNLOAD_LINK: 'Opened Download Link',
  CLICKED_SAVE: 'Clicked Save Resource',
  SAVED: 'Resource Saved to Library',
  SHOWED_PREVIEW: 'Showed Resource Preview',
}